<template>
  <FeedFilterTag v-for="category in categories" :key="category.id" :on-click="handleClick">
    {{ category?.name || '' }}
  </FeedFilterTag>
</template>

<script setup>
import _ from 'lodash-es';
import { CATEGORY_TYPE } from "@utils/constants";
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  data: {
    type: [Number, String],
    required: true
  }
});

const route = useRoute();
const routeCategory = useRouteCategory();
const flatCategories = _.chain(CATEGORY_TYPE)
  .values()
  .filter(value => !routeCategory.idPostCategory.value ? (value === CATEGORY_TYPE.ESHOP) : (value !== CATEGORY_TYPE.ESHOP))
  .map(value => useFlatCategories(value))
  .value();

const categories = computed(() => _.chain(flatCategories)
  .map(values => _.find(values.items.value, { id: +props.data }))
  .filter()
  .value()
);

const handleClick = async () => {
  const params = { ...route.query };
  _.forEach(_.keys(params), key => {
    if (/^p\[\d+\]$/.test(key)) {
      delete params[key];
    }
  });
  await useSearchParam(routeCategory.idCategory.value ? 'idCategory' : 'idPostCategory', '');
}

</script>
